/* FF Blog Teaser — mobile carousel behaviour
   Direction-aware edge-fade mask + prev/next arrows, matching the
   collection carousel. Fade/arrow state derive from scroll position;
   both switch off at the track ends and when there's no overflow. */
(function () {
  function cssNum(el, prop) {
    return parseFloat(getComputedStyle(el).getPropertyValue(prop)) || 0;
  }

  function initCarousel(section) {
    var track = section.querySelector('.ff-bt__grid');
    if (!track || track.dataset.btInit === '1') return;
    track.dataset.btInit = '1';

    var prev = section.querySelector('.ff-bt__arrow--prev');
    var next = section.querySelector('.ff-bt__arrow--next');

    function update() {
      var overflow = track.scrollWidth > Math.ceil(track.clientWidth) + 1;
      section.classList.toggle('ff-bt--scrollable', overflow);

      var fadeW = cssNum(track, '--ff-bt-fade-w');
      var fadeOp = parseFloat(getComputedStyle(track).getPropertyValue('--ff-bt-fade-op')) || 0;
      var maxX = Math.max(0, track.scrollWidth - track.clientWidth);
      var x = Math.max(0, Math.min(track.scrollLeft, maxX));

      if (!overflow || fadeW <= 0 || fadeOp <= 0) {
        track.style.setProperty('--fadeL', '0px');
        track.style.setProperty('--fadeR', '0px');
        track.style.setProperty('--fadeLa', '0');
        track.style.setProperty('--fadeRa', '0');
      } else {
        var ramp = Math.max(1, fadeW * 1.25);
        var leftProg = Math.min(1, x / ramp);
        var rightProg = Math.min(1, (maxX - x) / ramp);
        track.style.setProperty('--fadeL', (fadeW * leftProg).toFixed(1) + 'px');
        track.style.setProperty('--fadeR', (fadeW * rightProg).toFixed(1) + 'px');
        track.style.setProperty('--fadeLa', (leftProg * fadeOp).toFixed(3));
        track.style.setProperty('--fadeRa', (rightProg * fadeOp).toFixed(3));
      }

      if (prev) prev.classList.toggle('is-off', !overflow || x <= 1);
      if (next) next.classList.toggle('is-off', !overflow || Math.ceil(x + track.clientWidth) >= track.scrollWidth - 1);
    }

    var raf;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update).catch(function () {});
    }

    function step(dir) {
      var card = track.querySelector('.ff-bt__card');
      var gap = cssNum(track, 'column-gap') || cssNum(track, 'gap') || 16;
      var amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    update();
  }

  function init() {
    document.querySelectorAll('.ff-bt--swipe').forEach(initCarousel);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    var s = (e.target && e.target.querySelector) ? e.target.querySelector('.ff-bt--swipe') : null;
    if (s) initCarousel(s);
  });
})();